// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YatK","selected":"styles_selected__3gQJE"};